module.exports = __webpack_public_path__ + "img/78.6a84332d.jpg";